<template>
  <v-col
    id="blue_side_bar"
    class="side-bar d-flex justify-content-space-between flex-column"
  >
    <div>
      <img src="../../../public/newapalylogowhite.png" alt="" width="120" height="50" class="mobile-img" />
    </div>

    <v-col class="middle-sidebar dont-display"
     v-if="!$store.getters.verifyUser 
     && ( $route.path != '/login' 
     && $route.path != '/new-login' 
     && $route.path != '/register' 
     && $route.path != '/new-register' 
     && $route.path != '/org-exists'  
     && $route.path != '/change-pass'  
     && $route.path != '/set-pass'  
     && $route.path != '/auth/simple/verify/account' )">

      <h2 class="white--text font sidebar-title">
        {{ title }}
      </h2>
    </v-col>
    <span v-else class="image-class mb-0 text-center dont-display">    
      <img src="../../../public/login-img.png" class="new-img"> 
       <h1 class="white--text font sidebar-title mt-15" >
        {{ title }}
      </h1>
    </span>
    <!-- <v-col v-if="$route.path == '/login' 
     || $route.path == '/new-login'
     || $route.path == '/register'
     || $route.path == '/new-register'
     || $route.path == '/org-exists' 
     ||  $route.path != '/change-pass' 
     ||  $route.path != '/set-pass' 
     ||  $route.path != '/auth/simple/verify/account'  ">
  
      <div class="paddings">
        <p class="text-center newlogin" >
        {{ desc }}
        </p>
      </div>
    </v-col>
    <v-col v-else>
      <h2 class="paragraphs font" >
        {{ desc }}
      </h2>
      
    </v-col> -->
    
    <v-col class="end-sidebar">
     
    </v-col>
    <div class="white--text font text-center mb-5 dont-display">
      Copyright (c)  {{ new Date().getFullYear()}} - Apaly Health Inc
    </div>
  </v-col>
  
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      icons: ["mdi-home", "mdi-email", "mdi-calendar", "mdi-delete"],
      padless: false,
      whoYouAreTitle: "Tell us who you are",
      whoYouAreP:
        "We'll quide you throught our simple sing up process so that you can easily experiance the benefits of Apaly Health's employer and provider collaboration platform",
      aboutYouTitle: "Tell us about you",
    };
  },
  computed: {
    title() {
      let str;
      let path = this.$route.path;
      if (path == "/login") {
        str = "Digital Direct Healthcare.";
      }
      else if (path == "/login" 
      || path == "/new-login" 
      || path == "/register" 
      || path == "/new-register" 
      || path == "/org-exists" 
      || path == "/change-pass" 
      || path == "/set-pass" 
      ||  path == '/auth/simple/verify/account') {
        str = "Digital Direct Connect.";
      } else if (path == "/select-type") {
        str = "Tell us who you are.";
      } else {
        str = this.$store.state.sideBarTitle;
      }

      return str;
    },
    desc() {
      let str;
      let path = this.$route.path;
      if (path == "/login") {
        str = "";
      }
      if (path == "/login" 
      || path == "/new-login" 
      || path == "/register" 
      || path == "/new-register" 
      || path == "/org-exists" 
      || path == "/change-pass" 
      || path == "/set-pass" 
      ||  path == '/auth/simple/verify/account') {
        str = "Makes advanced primary care services accessible to employees and their families on a national scale by connecting DPC providers and self-funded employers.";
      } else if (path == "/select-type") {
        str =
          "We'll guide you throught our simple sing up process so that you can easily experience the benefits of Apaly Helath";
      } else {
        str = this.$store.state.sideBarDesc;
      }

      return str;
    },
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods:{
    handleScroll () {
      if(window.innerWidth > 950){
      document.getElementById('blue_side_bar').style.height = '100%'

      }
    }
  }
};
</script>
<style>
.paragraphs {
  color: white;
  font-family: "Mulish", sans-serif;
  font-weight: bolder;
}
.side-bar {
  background: #214a82;
  min-height: 100vh;
}

.middle-sidebar {
  display: flex;
  align-items: center;
}
.end-sidebar {
  display: flex;
  align-items: flex-end;
}
.newlogin{
  font-family: 'Mulish';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 150%;
color: white;
text-align: center;
letter-spacing: 0.005em;
  
}
.new-img{
  width: 75%;
  border: 30px solid rgba(255, 255, 255, 0.1) ;
  border-radius: 10px;
  
}
.image-class{
  margin-top: 25vh;
}
.paddings{
  padding-left: 25%;
  padding-right: 25%;
}
@media only screen and (max-width: 1264px) {
  .dont-display{
    display: none;
  }
  .side-bar {
    min-height: 10vh !important;
    overflow: auto;
  }
  .sidebar-title {
    font-size: 1.2rem;
  }
  .end-sidebar {
    display: none;
    justify-content: center;
  }
  .middle-sidebar {
    display: flex;
    align-items: flex-start;
  }
  .mobile-img{
    height: 55px !important;
    width: 120px !important;
  }
}
</style>
